var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-card-tabs"},[_c('r-tabs',{attrs:{"indent":"","metro":""},model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},_vm._l((_vm.filteredTabs),function(item){return _c('r-tab',{key:item.id,attrs:{"id":item.id,"name":item.title}},[_c(item.type,{tag:"component"})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }